import React, { Component } from 'react';
import classNames from 'classnames';
import { NavItem } from '../../atoms';

import './styles.css';

/**
 * @typedef {Object} NavItemObj
 * @prop {React.ReactNode} children
 * @prop {string} href
 */

/**
 * A group of navigation items.
 *
 * @typedef {Object} Props
 * @prop {Array<NavItemObj>} navItems
 * @prop {string} [className]
 *
 * @augments {Component<Props>}
 */
export default class NavItemGroup extends Component {

	genClassName = (props) => classNames('NavItemGroup', props.className);

	mapChildren = ({ children, href }) => (
		<li key={children.toString()}>
			<NavItem href={href}>
				{children}
			</NavItem>
		</li>
	)

	render () {
		const className = this.genClassName(this.props);

		return (
			<nav className={className}>
				<ul>
					{this.props.navItems.map(this.mapChildren)}
				</ul>
			</nav>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/molecules/NavItemGroup/NavItemGroup.js